import { i18n } from "us.helper";

export enum ImportFileParams {
  COUNTRY_CODE = "NO",
  POSTAL_CODE = "PostalCode",
  COURT_FILE_IMPORT = "CourtFile",
  POSTAL_CODE_FILE_IMPORT = "PostalFile",
  NOWEGIAN_CURRENCY = "NOK",
}

export const MaxFileSize = "5";

export const COURT_TABLE_COLUMN_HEADERS_FOR_TYPE_FORLIKSRAD = [
  "POLITI_DISTRIKT",
  "FIRMA_ID",
  "FIRMA_NAVN",
  "ADRESSE_1_FIRMA",
  "ADRESSE_2_FIRMA",
  "POSTNR_FIRMA",
  "POSTED_FIRMA",
  "FORLIKSRÅD_NAVN",
  "ORG_NR_FORLIKSRÅD",
  "ADRESSE1_FORLIKSRÅD",
  "ADRESSE2_FORLIKSRÅD",
  "POST_NR_FORLIKSRÅD",
  "POSTSTED_FORLIKSRÅD",
  "UNDERLIGGENDE_POSTNR",
  "UNDERLIGGENDE_POSTSTED",
  "UNDERLIGGENDE_KOMMUNE_ID",
  "UNDERLIGGENDE_KOMMUNE_NAVN",
];

export const COURT_TABLE_COLUMN_HEADERS_FOR_TYPE_NAMSMANN = [
  "POLITI_DISTRIKT",
  "POLITI_DISTRIKT_ID",
  "FO_NR_NAMSMANN",
  "FIRMA_ID",
  "NAMSMANN",
  "ADRESSE1_NAMSMANN",
  "ADRESSE2_NAMSMANN",
  "POSTNR_NAMSMANN",
  "POSTED_NAMSMANN",
  "UNDERLIGGENDE_POST_NR",
  "UNDERLIGGENDE_POSTSTED",
  "KOMMUNENAVN",
  "KOMMUNE_ID",
];

export const POSTAL_CODE_TABLE_COLUMN_HEADERS = [
  "US.COLLECTION.ADMIN:POSTALAREAS.POSTALCODE",
  "US.COLLECTION.ADMIN:POSTALAREAS.POSTALPLACE",
  "US.COLLECTION.ADMIN:POSTALAREAS.MUNICIPALITYCODE",
  "US.COLLECTION.ADMIN:POSTALAREAS.MUNICIPALITYNAME",
  "US.COLLECTION.ADMIN:POSTALAREAS.CATEGORY",
];

export enum courtTypeIds {
  NAMSMANN = 3,
  FORLIKSRAD = 2,
}
